/**
 * Dauerhafter Speicher (PV-B27) und Speicheranzeige (PV-B29).
 *
 * Das Betriebssystem darf lokal abgelegte Daten verwerfen, wenn der Speicher
 * knapp wird oder die Anwendung lange nicht benutzt wurde. Dagegen muss
 * ausdruecklich dauerhafter Speicher angefordert werden — sonst steht der
 * Vertrieb irgendwann mit einem leeren Geraet beim Kunden.
 *
 * Apple ist hier deutlich strenger als Android und Windows. Wird die Anfrage
 * abgelehnt, muss der Nutzer das erfahren; dann ist das Geraet nicht
 * verlaesslich offline nutzbar. Genau das prueft PV-B30 auf dem Zielgeraet.
 */

export interface Speicherlage {
  dauerhaft: boolean;
  /** false, wenn der Browser die Frage gar nicht kennt. */
  beantwortbar: boolean;
  belegtBytes?: number;
  verfuegbarBytes?: number;
}

export async function fordereDauerhaftenSpeicher(): Promise<Speicherlage> {
  if (!('storage' in navigator) || !navigator.storage.persist) {
    return { dauerhaft: false, beantwortbar: false };
  }
  const schonDauerhaft = await navigator.storage.persisted();
  const dauerhaft = schonDauerhaft || (await navigator.storage.persist());
  return { dauerhaft, beantwortbar: true, ...(await speicherstand()) };
}

export async function speicherstand(): Promise<{
  belegtBytes?: number;
  verfuegbarBytes?: number;
}> {
  if (!('storage' in navigator) || !navigator.storage.estimate) return {};
  const schaetzung = await navigator.storage.estimate();
  return {
    ...(schaetzung.usage !== undefined ? { belegtBytes: schaetzung.usage } : {}),
    ...(schaetzung.quota !== undefined ? { verfuegbarBytes: schaetzung.quota } : {}),
  };
}

/** Ab wann gewarnt wird: weniger als 500 MB oder unter 10 Prozent frei. */
export function speicherWirdKnapp(lage: Speicherlage): boolean {
  if (lage.belegtBytes === undefined || lage.verfuegbarBytes === undefined) return false;
  const frei = lage.verfuegbarBytes - lage.belegtBytes;
  return frei < 500 * 1024 * 1024 || frei / lage.verfuegbarBytes < 0.1;
}

export function alsMb(bytes: number | undefined): string {
  if (bytes === undefined) return '—';
  if (bytes > 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(1)} GB`;
  return `${Math.round(bytes / 1024 ** 2)} MB`;
}
